var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"record-box"},[_c('el-button',{on:{"click":_vm.luyin}},[_vm._v("录音开始")]),_c('LuyinBtn')],1)}
var staticRenderFns = []

export { render, staticRenderFns }